<template>
  <div id="app">
    <v-card color="grey lighten-5" flat>


      <v-container fluid>
        <v-layout row wrap>

          <v-flex xs12 sm12 md12>
            <v-layout row wrap>

              <v-flex xs12 pl-1 sm12 md12>
                <v-layout row wrap class="pl-1 pr-1 project overdue">
                  <v-toolbar flat="" size="120px" dark color="white">
                    <v-toolbar-title> <span class="subheading black--text">
                        Fatura Adres Bilgileri
                      </span> </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 pa-1>
                <v-card flat>
                  <v-layout row wrap class="pa-3 project overdue">
                    <v-flex pt-1 pb-3 sm112 xs12 md12>
                      <v-layout row wrap>
                        <v-flex pa-1 sm10 xs12 md9>
                          <div class="subheading-2 font-weight-	  black--text">
                            <v-icon color="grey">account_box </v-icon> &nbsp; {{Current.Unvan}}
                          </div>
                        </v-flex>


                      </v-layout>
                    </v-flex>

                    <v-flex xs12 md12>
                      <v-layout row wrap>



                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>

                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">GSM</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.GSM}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">Telefon 1</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.Tel1}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>

                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">Telefon 2</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.Tel2}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>

                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">Telefon 3</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.Tel3}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>



                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">E-mail</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.Web}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">Web</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.Email}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">Adres1</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.Adres1}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">İlçe/İl</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.IlceIl}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex pa-1 sm2 xs2 md2>
                              <v-layout justify-left>
                                <div class="subheading	 justify-start   grey--text">Fatura Teslim Adresi</div>
                              </v-layout>
                            </v-flex>

                            <v-flex pa-1 xs10 md10>
                              <v-layout justify-start>
                                <div class="justify-end align-center  grey--text fill-height subheading ">
                                  : {{Current.TesAdres}}</div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>
                  <v-divider></v-divider>
                </v-card>


              </v-flex>
            </v-layout>

          </v-flex>

        </v-layout>
      </v-container>





    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'

  import VeLine from 'v-charts/lib/line.common'
  import VeBar from 'v-charts/lib/bar.common'
  import VePie from 'v-charts/lib/pie.common'
  import VeHistogram from 'v-charts/lib/histogram.common'
  import tarihcomp from '../customcomp/tarihim'


  export default {
    data() {
      return {
        Current: {
          Unvan: null,
          Tel1: null,
          Tel2: null,
          Tel3: null,
          Email: null,
          GSM: null,
          Web: null,
          Adres1: null,
          IlceIl: null,
          TesAdres: null
        },
        ListInput: {
          SirketKodu: 1,
          BaslangicTarihi: '2020-02-01',
          BitisTarihi: getDateNow(),
          Carikod: null,
          HavaYoluKodu: null,
          FormNo: null,
          BiletNo: null,
          TextSearch: null,
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'SalesDate'
          },
          Filtreler: {
            CariKod: 'ARKMAN',
            Havayollari: [],
            Parkurlar: [],
            HatTipi: [], // I : iç hat, D: Dış hat, B: Bsp
            BiletTipi: 'S', // S: Satış, I: Iade, V : Void
            Ucus1: null,
            Ucus2: null,
            KesenKisi: null,
            PosKod: null,
            DekontBas: false,
            KrediKartNo: null,
            GiderPusulasi: 0, // 0: seçim yok, 1 : basılmış, 2 : basılmamış
            AcentaFatNo: 0, // 0 : seçim yok, 1 : fatura olan, 2 : fatura olmayan
            IadeFatura: false,
            GeciciCari: 0, // 0 : hepsi, 1 : geci haric, 2 : sadece gecici
            FaturaStatus: 0, // 0 : hepsi, 1 : faturalanmamışlar, 2 : faturalanmışlar
            BaslangicTutar: 0,
            BitisTutar: 0,
            TutarTip: 0 // 0 : NetTutar, 1 : Bilet Tutar, 2 : Servis Tutar, 3 : Iskonto Tutar
          }
        },

        loading1: true,
        load1: true,
        satis: 0,
        iade: 0,
        voidbilet: 0,
        toplamsatis: 0,
        toplamiade: 0,
        toplamservis: 0,
        toplamborc: 0,
        vadesigelenborc: 0,
        faturaedilmisbilet: 0,
        faturaedilmemisbilet: 0,
        gecicibilet: 0,

        kagitfatura: 0,
        earsivgonderilen: 0,
        earsivgonderilmeyen: 0,
        efaturagonderilen: 0,
        efaturagonderilmeyen: 0,

        chartSettings: {
          title: {
            show: true,
            text: 'eaieaei'
          },
          label: {
            show: true
          },
          axisSite: {
            right: ['growthRate']
          },
          yAxisType: ['KMB'],
          yAxisName: ['Adet']
        },
        drawer: null,

        currentDebtTotal: 0,
        currentCreditTotal: 58,
        debtTotal: 0,
        creditTotal: 0,
        valid: true,
        tooltip: false,
        el: null,
        charthavayolunagore: {
          rows: [],
          columns: ['firma', 'satis', 'iade'],
        },

        chartsatistipinegore: {
          columns: ['tarih', 'İç Hat Satış Adet', 'İç Hat İade Adet', 'Dış Hat Satış Adet', 'Dış Hat İade Adet'],
          rows: []
        },



        chartData: {
          columns: ['date', 'PV', 'Order', 'OrderRate'],
          rows: [{
              'date': 'Satılan Bilet Sayısı',
              'PV': 1393,
              'Order': 1093,
              'OrderRate': 0.32
            },
            {
              'date': '1/2',
              'PV': 3530,
              'Order': 3230,
              'OrderRate': 0.26
            },
            {
              'date': '1/3',
              'PV': 2923,
              'Order': 2623,
              'OrderRate': 0.76
            },
            {
              'date': '1/4',
              'PV': 1723,
              'Order': 1423,
              'OrderRate': 0.49
            },
            {
              'date': '1/5',
              'PV': 3792,
              'Order': 3492,
              'OrderRate': 0.323
            },
            {
              'date': '1/6',
              'PV': 10093,
              'Order': 4293,
              'OrderRate': 0.78
            }
          ]
        },

        chartsatis: {
          columns: ['tip', 'İç Hat Satış', 'İç Hat İade', 'Dış Hat Satış', 'Dış Hat İade'],
          rows: [{
              'tip': 'Aralık',
              'İç Hat Satış': 180,
              'İç Hat İade': 18,
              'Dış Hat Satış': 120,
              'Dış Hat İade': 20
            }, {
              'tip': 'Ocak',
              'İç Hat Satış': 150,
              'İç Hat İade': 55,
              'Dış Hat Satış': 110,
              'Dış Hat İade': 40,
            },

          ]
        },

        charthavayolu: {
          columns: ['firma', 'satis', 'iade'],
          rows: [{
            'firma': 'TK',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'H9',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'KK',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'OHY',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'XQ',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'Diğer',
            'satis': 0,
            'iade': 0
          }]
        },

        colors: ['#03A9F4', '#F44336'],


        chartsatisseklinegore: {

          columns: ['tipi', 'adet'],
          rows: []

        },
      }
    },
    beforeMount: beforeMount,
    methods: {
      BiletListele,
      getList: getList,
      getDateNow: getDateNow
    },
    components: {
      tarihcomp,
      VeLine,
      VeBar,
      VePie,
      VeHistogram
    },





    mounted() {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (credentials != null && credentials != undefined) {
        this.Current.Unvan = credentials.CariBilgi.Unvan
        this.Current.Tel1 = credentials.CariBilgi.Tel1
        this.Current.Tel2 = credentials.CariBilgi.Tel2
        this.Current.Tel3 = credentials.CariBilgi.Tel3
        this.Current.Email = credentials.CariBilgi.Email
        this.Current.Web = credentials.CariBilgi.Web
        this.Current.Adres1 = credentials.CariBilgi.Adres1
        this.Current.IlceIl = credentials.CariBilgi.IlceIl
        this.Current.TesAdres = credentials.CariBilgi.TesAdres
        this.Current.GSM = credentials.CariBilgi.GSM
      }

    }
  }






  function BiletListele() {




    var Params = this.ListInput;


    this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      //  this.itemsticket = response.body






    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

        this.load1 = true
        this.progress = false

      }
    })




  }




  function getList() {

    if (this.$refs.formsalesreport.validate()) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.progress = true
      this.SummaryInfo.SirketKodu = credentials.SirketKodu
      var params = this.SummaryInfo
      this.load1 = false
      this.$http.post(auth.API_URL + 'api/TicketReport/SummaryInfoList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        var yenikayitdizi = []

        // grafik1
        if (response.body.HavayoluAdetList.length > 0) {
          response.body.HavayoluAdetList.forEach(element => {
            var yenikayit = {
              firma: element.HavaYoluKodu,
              satis: element.Adet,
              iade: element.IadeAdet
            }
            yenikayitdizi.push(yenikayit);
          });

          this.charthavayolunagore.rows = yenikayitdizi
        } else {
          var yenikayit = {
            firma: 0,
            satis: 0,
            iade: 0
          }
          yenikayitdizi.push(yenikayit);
          this.charthavayolunagore.rows = yenikayitdizi

        }

        //grafik3
        yenikayitdizi = [];

        if (response.body.GunSatisList.length > 0) {

          response.body.GunSatisList.forEach(element => {
            console.log('girdi')
            var yenikayit2 = {
              'tarih': element.TarihStr,
              'İç Hat Satış Adet': element.SatisAdetIcHat,
              'İç Hat İade': element.IadeAdetIcHat,
              'Dış Hat Satış Adet': element.SatisAdetDisHat,
              'Dış Hat İade Adet': element.IadeAdetDisHat
            }
            yenikayitdizi.push(yenikayit2);

          });

          this.chartsatistipinegore.rows = yenikayitdizi


        } else {

          var yenikayit2 = {
            'tarih': 0,
            'İç Hat Satış Adet': 0,
            'İç Hat İade': 0,
            'Dış Hat Satış Adet': 0,
            'Dış Hat İade Adet': 0
          }
          yenikayitdizi.push(yenikayit2);

          this.chartsatistipinegore.rows = yenikayitdizi
        }






        //grafik2

        yenikayitdizi = [];

        var satistipi = {
          'tipi': 'Kredili',
          'adet': response.body.SatisSekliAdet.KrediliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'R-KK',
          'adet': response.body.SatisSekliAdet.RKartliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'F-KK',
          'adet': response.body.SatisSekliAdet.FKartliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'C-KK',
          'adet': response.body.SatisSekliAdet.CKartliAdet
        };
        yenikayitdizi.push(satistipi);

        this.chartsatisseklinegore.rows = yenikayitdizi;

        this.progress = false
        this.load1 = true




        this.satis = response.body.SatisAdet;
        this.iade = response.body.IadeAdet;
        this.voidbilet = response.body.VoidAdet;
        this.toplamsatis = response.body.BiletSatisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.toplamiade = response.body.BiletIadeTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.toplamservis = response.body.SatisServisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.vadesigelenborc = response.body.BorcBilgi.VadesiGecenBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
          '$1,')
        this.toplamborc = response.body.BorcBilgi.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        this.faturaedilmisbilet = response.body.FaturalanmisBiletAdet;
        this.faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet;
        this.gecicibilet = response.body.GecicideAdet;
        this.kagitfatura = response.body.FaturaTipAdet.KagitFaturaAdet
        this.earsivgonderilen = response.body.FaturaTipAdet.EArsivGonderilenAdet
        this.earsivgonderilmeyen = response.body.FaturaTipAdet.EArsivGonderilmeyenAdet
        this.efaturagonderilen = response.body.FaturaTipAdet.EFaturaGonderilenAdet
        this.efaturagonderilmeyen = response.body.FaturaTipAdet.EFaturaGonderilmeyenAdet




      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        }
      })

    }
  }



  function beforeMount() {

  }






  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>

<style>
  .project.complete {
    border-left: 4px solid #039BE5;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid tomato;
  }
</style>